import { useState } from "react";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { authApi, formatApiErrorDetail } from "@/lib/auth";

const inputClass =
  "w-full rounded-none border-0 border-b border-white/20 bg-transparent px-0 py-3 text-sm text-white placeholder:text-slate-500 focus-visible:border-accent focus-visible:outline-none transition-colors";

export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await authApi.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated.");
      setCurrent("");
      setNext("");
      onOpenChange(false);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-none border-gold/25 bg-ink p-8 text-white" data-testid="change-password-dialog">
        <DialogTitle className="flex items-center gap-3 font-display text-2xl font-normal">
          <KeyRound className="h-5 w-5 text-gold" /> Change password
        </DialogTitle>
        <DialogDescription className="text-sm text-slate-400">Use at least 10 characters.</DialogDescription>
        <form onSubmit={submit} className="mt-6 space-y-6">
          <div>
            <label htmlFor="cp-current" className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">Current password</label>
            <input id="cp-current" data-testid="change-password-current" type="password" required autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} className={inputClass} />
          </div>
          <div>
            <label htmlFor="cp-next" className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">New password</label>
            <input id="cp-next" data-testid="change-password-new" type="password" required minLength={10} autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} className={inputClass} />
          </div>
          <button type="submit" data-testid="change-password-submit" disabled={busy} className="btn-sweep btn-sweep-light flex items-center gap-2 border border-accent bg-accent px-6 py-3 font-mono text-[11px] uppercase tracking-[0.22em] text-ink">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Update password
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
